import { useMutation } from '@tanstack/react-query'
import { registInviteCode } from '../../service/user'

function useRegistInviteCode() {
  return useMutation({
    mutationKey: ['regist-invte-code'],
    mutationFn: registInviteCode,
  })
}

export default useRegistInviteCode
